import { render, staticRenderFns } from "./PathCrud.vue?vue&type=template&id=525da4ab&scoped=true"
import script from "./PathCrud.vue?vue&type=script&lang=js"
export * from "./PathCrud.vue?vue&type=script&lang=js"
import style0 from "./PathCrud.vue?vue&type=style&index=0&id=525da4ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525da4ab",
  null
  
)

export default component.exports